export default __webpack_public_path__ + "static/media/blank-prediction.3a71756d.svg";